import lazyScreen from '../utils/lazyScreen';
const ARItemStatus = lazyScreen(() => import('../pages/ar/ARItemStatus/index.js'), 'pages/ar/ARItemStatus/index.js');
const ARItemStatuses = lazyScreen(() => import('../pages/ar/ARItemStatuses/index.js'), 'pages/ar/ARItemStatuses/index.js');
const ARPriceList = lazyScreen(() => import('../pages/ar/ARPriceList/index.js'), 'pages/ar/ARPriceList/index.js');
const ARPriceLists = lazyScreen(() => import('../pages/ar/ARPriceLists/index.js'), 'pages/ar/ARPriceLists/index.js');
const ARPromotion = lazyScreen(() => import('../pages/ar/ARPromotion/index.js'), 'pages/ar/ARPromotion/index.js');
const ARPromotions = lazyScreen(() => import('../pages/ar/ARPromotions/index.js'), 'pages/ar/ARPromotions/index.js');
const ARAppointment = lazyScreen(() => import('../pages/ar/ARAppointment/index.js'), 'pages/ar/ARAppointment/index.js');
const ARAppointments = lazyScreen(() => import('../pages/ar/ARAppointments/index.js'), 'pages/ar/ARAppointments/index.js');
const AROrder = lazyScreen(() => import('../pages/ar/AROrder/index.js'), 'pages/ar/AROrder/index.js');
const AROrders = lazyScreen(() => import('../pages/ar/AROrders/index.js'), 'pages/ar/AROrders/index.js');
const ARIssue = lazyScreen(() => import('../pages/ar/ARIssue/index.js'), 'pages/ar/ARIssue/index.js');
const ARIssues = lazyScreen(() => import('../pages/ar/ARIssues/index.js'), 'pages/ar/ARIssues/index.js');
const ARReturn = lazyScreen(() => import('../pages/ar/ARReturn/index.js'), 'pages/ar/ARReturn/index.js');
const ARReturns = lazyScreen(() => import('../pages/ar/ARReturns/index.js'), 'pages/ar/ARReturns/index.js');
const ARCredit = lazyScreen(() => import('../pages/ar/ARCredit/index.js'), 'pages/ar/ARCredit/index.js');
const ARCredits = lazyScreen(() => import('../pages/ar/ARCredits/index.js'), 'pages/ar/ARCredits/index.js');
const ARInvoice = lazyScreen(() => import('../pages/ar/ARInvoice/index.js'), 'pages/ar/ARInvoice/index.js');
const ARInvoices = lazyScreen(() => import('../pages/ar/ARInvoices/index.js'), 'pages/ar/ARInvoices/index.js');
const ARPayments = lazyScreen(() => import('../pages/ar/ARPayments/index.js'), 'pages/ar/ARPayments/index.js');
const ARAgingReport = lazyScreen(() => import('../pages/ar/ARAgingReport/index.js'), 'pages/ar/ARAgingReport/index.js');
const ARCustomerStatement = lazyScreen(() => import('../pages/ar/ARCustomerStatement/index.js'), 'pages/ar/ARCustomerStatement/index.js');
const ARBalance = lazyScreen(() => import('../pages/ar/ARBalance/index.js'), 'pages/ar/ARBalance/index.js');
const ServiceCard = lazyScreen(() => import('../pages/ar/ServiceCard/index.js'), 'pages/ar/ServiceCard/index.js');
const ServiceCards = lazyScreen(() => import('../pages/ar/ServiceCards/index.js'), 'pages/ar/ServiceCards/index.js');
const DepositCard = lazyScreen(() => import('../pages/ar/DepositCard/index.js'), 'pages/ar/DepositCard/index.js');
const DepositCards = lazyScreen(() => import('../pages/ar/DepositCards/index.js'), 'pages/ar/DepositCards/index.js');
const ARServicePlan = lazyScreen(() => import('../pages/ar/ARServicePlan/index.js'), 'pages/ar/ARServicePlan/index.js');
const ARServicePlans = lazyScreen(() => import('../pages/ar/ARServicePlans/index.js'), 'pages/ar/ARServicePlans/index.js');
const ARServiceOrder = lazyScreen(() => import('../pages/ar/ARServiceOrder/index.js'), 'pages/ar/ARServiceOrder/index.js');
const ARServiceOrders = lazyScreen(() => import('../pages/ar/ARServiceOrders/index.js'), 'pages/ar/ARServiceOrders/index.js');
const ARTradeIn = lazyScreen(() => import('../pages/ar/ARTradeIn/index.js'), 'pages/ar/ARTradeIn/index.js');
const ARTradeIns = lazyScreen(() => import('../pages/ar/ARTradeIns/index.js'), 'pages/ar/ARTradeIns/index.js');
const ARWarranty = lazyScreen(() => import('../pages/ar/ARWarranty/index.js'), 'pages/ar/ARWarranty/index.js');
const ARWarranties = lazyScreen(() => import('../pages/ar/ARWarranties/index.js'), 'pages/ar/ARWarranties/index.js');
const ARWarrantyClaim = lazyScreen(() => import('../pages/ar/ARWarrantyClaim/index.js'), 'pages/ar/ARWarrantyClaim/index.js');
const ARWarrantyClaims = lazyScreen(() => import('../pages/ar/ARWarrantyClaims/index.js'), 'pages/ar/ARWarrantyClaims/index.js');
const ARAssetRegistration = lazyScreen(() => import('../pages/ar/ARAssetRegistration/index.js'), 'pages/ar/ARAssetRegistration/index.js');
const ARAssetRegistrations = lazyScreen(() => import('../pages/ar/ARAssetRegistrations/index.js'), 'pages/ar/ARAssetRegistrations/index.js');
const ARProductTrial = lazyScreen(() => import('../pages/ar/ARProductTrial/index.js'), 'pages/ar/ARProductTrial/index.js');
const ARProductTrials = lazyScreen(() => import('../pages/ar/ARProductTrials/index.js'), 'pages/ar/ARProductTrials/index.js');
const ARDeliveryInspection = lazyScreen(() => import('../pages/ar/ARDeliveryInspection/index.js'), 'pages/ar/ARDeliveryInspection/index.js');
const ARDeliveryInspections = lazyScreen(() => import('../pages/ar/ARDeliveryInspections/index.js'), 'pages/ar/ARDeliveryInspections/index.js');
const ARProductCampaign = lazyScreen(() => import('../pages/ar/ARProductCampaign/index.js'), 'pages/ar/ARProductCampaign/index.js');
const ARProductCampaigns = lazyScreen(() => import('../pages/ar/ARProductCampaigns/index.js'), 'pages/ar/ARProductCampaigns/index.js');
const CustomerAsset = lazyScreen(() => import('../pages/ar/CustomerAsset/index.js'), 'pages/ar/CustomerAsset/index.js');
const CustomerAssets = lazyScreen(() => import('../pages/ar/CustomerAssets/index.js'), 'pages/ar/CustomerAssets/index.js');
const ARFinancingPlan = lazyScreen(() => import('../pages/ar/ARFinancingPlan/index.js'), 'pages/ar/ARFinancingPlan/index.js');
const ARFinancingPlans = lazyScreen(() => import('../pages/ar/ARFinancingPlans/index.js'), 'pages/ar/ARFinancingPlans/index.js');
const ARCoveragePlan = lazyScreen(() => import('../pages/ar/ARCoveragePlan/index.js'), 'pages/ar/ARCoveragePlan/index.js');
const ARCoveragePlans = lazyScreen(() => import('../pages/ar/ARCoveragePlans/index.js'), 'pages/ar/ARCoveragePlans/index.js');
const ARCoverageClaim = lazyScreen(() => import('../pages/ar/ARCoverageClaim/index.js'), 'pages/ar/ARCoverageClaim/index.js');
const ARCoverageClaims = lazyScreen(() => import('../pages/ar/ARCoverageClaims/index.js'), 'pages/ar/ARCoverageClaims/index.js');
const ARMaintainPlan = lazyScreen(() => import('../pages/ar/ARMaintainPlan/index.js'), 'pages/ar/ARMaintainPlan/index.js');
const ARMaintainPlans = lazyScreen(() => import('../pages/ar/ARMaintainPlans/index.js'), 'pages/ar/ARMaintainPlans/index.js');
const ARMaintainReminder = lazyScreen(() => import('../pages/ar/ARMaintainReminder/index.js'), 'pages/ar/ARMaintainReminder/index.js');
const ARMaintainReminders = lazyScreen(() => import('../pages/ar/ARMaintainReminders/index.js'), 'pages/ar/ARMaintainReminders/index.js');

export default [
    {
        path: '/ar/ARItemStatus/:code',
        component: ARItemStatus
    },
    {
        path: '/ar/ARItemStatuses',
        component: ARItemStatuses
    },
    {
        path: '/ar/ARPriceList/:code',
        component: ARPriceList
    },
    {
        path: '/ar/ARPriceLists',
        component: ARPriceLists
    },
    {
        path: '/ar/ARPromotions',
        component: ARPromotions
    },
    {
        path: '/ar/ARPromotion/:code',
        component: ARPromotion
    },
    {
        path: '/ar/ARAppointment/:code',
        component: ARAppointment
    },
    {
        path: '/ar/ARAppointments',
        component: ARAppointments
    },
    // {
    //     path: '/ar/AROrder/:code',
    //     component: AROrderV2
    // },
    {
        path: '/ar/AROrder/:code',
        component: AROrder
    },
    {
        path: '/ar/AROrders',
        component: AROrders
    },
    {
        path: '/ar/ARIssue/:code',
        component: ARIssue
    },
    {
        path: '/ar/ARIssues',
        component: ARIssues
    },
    {
        path: '/ar/ARReturn/:code',
        component: ARReturn
    },
    {
        path: '/ar/ARReturns',
        component: ARReturns
    },
    {
        path: '/ar/ARCredit/:code',
        component: ARCredit
    },
    {
        path: '/ar/ARCredits',
        component: ARCredits
    },
    {
        path: '/ar/ARInvoice/:code',
        component: ARInvoice
    },
    {
        path: '/ar/ARInvoices',
        component: ARInvoices
    },
    {
        path: '/ar/ARPayments',
        component: ARPayments
    },
    {
        path: '/ar/ARAgingReport',
        component: ARAgingReport
    },
    {
        path: '/ar/ARCustomerStatement',
        component: ARCustomerStatement
    },
    {
        path: '/ar/ARBalance',
        component: ARBalance
    },
    {
        path: '/ar/ServiceCard/:code',
        component: ServiceCard
    },
    {
        path: '/ar/ServiceCards',
        component: ServiceCards
    },
    {
        path: '/ar/DepositCard/:code',
        component: DepositCard
    },
    {
        path: '/ar/DepositCards',
        component: DepositCards
    },
    {
        path: '/ar/ARServicePlan/:code',
        component: ARServicePlan
    },
    {
        path: '/ar/ARServicePlans',
        component: ARServicePlans
    },
    {
        path: '/ar/ARServiceOrder/:code',
        component: ARServiceOrder
    },
    {
        path: '/ar/ARServiceOrders',
        component: ARServiceOrders
    },
    {
        path: '/ar/ARTradeIn/:code',
        component: ARTradeIn
    },
    {
        path: '/ar/ARTradeIns',
        component: ARTradeIns
    },
    {
        path: '/ar/ARWarranty/:code',
        component: ARWarranty
    },
    {
        path: '/ar/ARWarranties',
        component: ARWarranties
    },
    {
        path: '/ar/ARWarrantyClaim/:code',
        component: ARWarrantyClaim
    },
    {
        path: '/ar/ARWarrantyClaims',
        component: ARWarrantyClaims
    },
    {
        path: '/ar/ARAssetRegistration/:code',
        component: ARAssetRegistration
    },
    {
        path: '/ar/ARAssetRegistrations',
        component: ARAssetRegistrations
    },
    {
        path: '/ar/ARProductTrial/:code',
        component: ARProductTrial
    },
    {
        path: '/ar/ARProductTrials',
        component: ARProductTrials
    },
    {
        path: '/ar/ARDeliveryInspection/:code',
        component: ARDeliveryInspection
    },
    {
        path: '/ar/ARDeliveryInspections',
        component: ARDeliveryInspections
    },
    {
        path: '/ar/ARProductCampaign/:code',
        component: ARProductCampaign
    },
    {
        path: '/ar/ARProductCampaigns',
        component: ARProductCampaigns
    },
    {
        path: '/ar/CustomerAsset/:code',
        component: CustomerAsset
    },
    {
        path: '/ar/CustomerAssets',
        component: CustomerAssets
    },
    {
        path: '/ar/ARFinancingPlan/:code',
        component: ARFinancingPlan
    },
    {
        path: '/ar/ARFinancingPlans',
        component: ARFinancingPlans
    },
    {
        path: '/ar/ARCoveragePlan/:code',
        component: ARCoveragePlan
    },
    {
        path: '/ar/ARCoveragePlans',
        component: ARCoveragePlans
    },
    {
        path: '/ar/ARCoverageClaim/:code',
        component: ARCoverageClaim
    },
    {
        path: '/ar/ARCoverageClaims',
        component: ARCoverageClaims
    },
    {
        path: '/ar/ARMaintainPlan/:code',
        component: ARMaintainPlan
    },
    {
        path: '/ar/ARMaintainPlans',
        component: ARMaintainPlans
    },
    {
        path: '/ar/ARMaintainReminder/:code',
        component: ARMaintainReminder
    },
    {
        path: '/ar/ARMaintainReminders',
        component: ARMaintainReminders
    }
];
